"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userPermissions = exports.hasClearanceLevelForAction = exports.getUserRoles = exports.canExecuteMapper = exports.canExecuteContent = exports.canEditMapper = exports.canEditContent = exports.canDeleteMapper = exports.anyDeleteExecuteActionAllowed = exports.anyDeleteEditExecuteActionAllowed = void 0;
var _globalStates = require("../globalstates/globalStates");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var FILTERED_ROLES = ["uma_authorization", "offline_access", "openid", "profile", "email", "default-roles-userful"];
var hasClearanceLevelForAction = exports.hasClearanceLevelForAction = function hasClearanceLevelForAction(data, authUserID, permissions, actions, actionName) {
  var _data$clearanceLevelP;
  if (!data) {
    // security data missing due to source already deleted
    return true;
  }
  // if user is the owner of the source
  if (authUserID.value === data.userID) {
    return true;
  }
  // the content is open to all, it means no clearance levels are attached
  if (data.clearanceLevelPermissions.length === 0) return true;
  var clData = permissions.clearanceData || [];
  var matchingClearance = (_data$clearanceLevelP = data.clearanceLevelPermissions) === null || _data$clearanceLevelP === void 0 ? void 0 : _data$clearanceLevelP.filter(function (clID) {
    var match = clData === null || clData === void 0 ? void 0 : clData.filter(function (i) {
      return i.clearanceLevel.id.value === clID.value;
    });
    if (match.length === 0) return false;else {
      var matchedClearanceLevel = match[0];
      var action = actions.find(function (a) {
        return a.name === actionName;
      });
      var allActionIDs = matchedClearanceLevel.clearanceLevel.actions.map(function (action) {
        return action.value;
      });
      return allActionIDs.includes(action.id.value);
    }
  });
  return matchingClearance.length > 0;
};
var canEditContent = exports.canEditContent = function canEditContent(securityData) {
  var bool = hasClearanceLevelForAction(securityData, (0, _globalStates.getGlobalStates)().userData.userID, (0, _globalStates.getGlobalStates)().userPermission, (0, _globalStates.getGlobalStates)().actions, "edit");
  return bool;
};
var canExecuteContent = exports.canExecuteContent = function canExecuteContent(securityData) {
  return hasClearanceLevelForAction(securityData, (0, _globalStates.getGlobalStates)().userData.userID, (0, _globalStates.getGlobalStates)().userPermission, (0, _globalStates.getGlobalStates)().actions, "execute");
};

// if user can edit the mapping group
var canEditMapper = exports.canEditMapper = function canEditMapper(securityData) {
  var hasClearanceLevelPermission = hasClearanceLevelForAction(securityData, (0, _globalStates.getGlobalStates)().userData.userID, (0, _globalStates.getGlobalStates)().userPermission, (0, _globalStates.getGlobalStates)().actions, "edit") ? true : false;
  var hasRole = (0, _globalStates.getGlobalStates)().userPermission.isMapperUpdater;
  return hasClearanceLevelPermission && hasRole ? "canEdit" : "cannotEdit";
};

// if user can execute the mapping group
var canExecuteMapper = exports.canExecuteMapper = function canExecuteMapper(securityData) {
  var hasClearanceLevelPermission = hasClearanceLevelForAction(securityData, (0, _globalStates.getGlobalStates)().userData.userID, (0, _globalStates.getGlobalStates)().userPermission, (0, _globalStates.getGlobalStates)().actions, "execute") ? true : false;
  // const hasRole = (getGlobalStates().userPermission as UserPermission).isMapperUpdater;
  return hasClearanceLevelPermission ? "canExecute" : "cannotExecute";
};

// if user can delete the mapping group
var canDeleteMapper = exports.canDeleteMapper = function canDeleteMapper(securityData) {
  var hasClearanceLevelPermission = hasClearanceLevelForAction(securityData, (0, _globalStates.getGlobalStates)().userData.userID, (0, _globalStates.getGlobalStates)().userPermission, (0, _globalStates.getGlobalStates)().actions, "edit") ? true : false;
  var hasRole = (0, _globalStates.getGlobalStates)().userPermission.isMapperSuppressor;
  return hasClearanceLevelPermission && hasRole ? "canDelete" : "cannotDelete";
};
var anyDeleteEditExecuteActionAllowed = exports.anyDeleteEditExecuteActionAllowed = function anyDeleteEditExecuteActionAllowed(securityData) {
  var canDelete = canDeleteMapper(securityData) === "canDelete";
  var canEdit = canEditMapper(securityData) === "canEdit";
  var canExecute = canExecuteMapper(securityData) === "canExecute";
  return canDelete || canEdit || canExecute;
};
var anyDeleteExecuteActionAllowed = exports.anyDeleteExecuteActionAllowed = function anyDeleteExecuteActionAllowed(securityData) {
  var canDelete = canDeleteMapper(securityData) === "canDelete";
  var canExecute = canExecuteMapper(securityData) === "canExecute";
  return canDelete || canExecute;
};
var userPermissions = exports.userPermissions = function userPermissions(capabilities, clearanceData, keycloak) {
  var isAdminUser = ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.ADMIN);
  var canOverrideSecurityDataOwnerShip = ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS.OVERRIDE_SECURITY_DATA_OWNERSHIP, "userful-chronos");
  var isDecisionsAdmin = isAdminUser || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.DECISION_ADMIN) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.DECISIONS);
  var isDecisionsOperator = isDecisionsAdmin || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.DECISION_OPERATOR) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.DECISIONS);
  var isDecisionsUser = isDecisionsOperator || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.DECISION_USER) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.DECISIONS);
  var isRubyAdmin = isAdminUser || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.OPSTREAMS_ADMIN) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.OPSTREAMS);
  var isRubyUser = isRubyAdmin || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.OPSTREAMS_USER) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.OPSTREAMS);
  var isEngageAdmin = isAdminUser || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.ENGAGE_ADMIN) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.ENGAGE);
  var isEngagedUser = isEngageAdmin || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.ENGAGE_USER) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.ENGAGE);
  var isSapphireAdmin = isAdminUser || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.SPACE_ADMIN) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.SPACES);
  var isSapphireUser = isSapphireAdmin || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.SPACE_USER) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.SPACES);
  var isTrendsAdmin = isAdminUser || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.TRENDS_ADMIN) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.TRENDS);
  var isTrendsUser = isTrendsAdmin || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.TRENDS_USER) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.TRENDS);
  var isEdgeAIUser = isAdminUser || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.EDGE_AI);

  // to view the mapper
  var isMapperViewer = ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS.MAPPER_VIEWER, "userful-chronos");
  // to create the mapper
  var isMapperCreator = ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS.MAPPER_CREATOR, "userful-chronos");
  // edit the mapper only, NOT delete
  var isMapperUpdater = ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS.MAPPER_UPDATER, "userful-chronos");
  // deleting the mapper
  var isMapperSuppressor = ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS.MAPPER_SUPPRESSOR, "userful-chronos");
  // all permissions
  var isMapperAdmin = isMapperViewer && isMapperCreator && isMapperUpdater && isMapperSuppressor;
  // for deleting the source
  var isSourceSuppressor = ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS.SOURCE_SUPPRESSOR, "userful-chronos");
  // for fetching the list of sources and playlists
  var isSAMSourceViewer = ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS.SAM_SOURCE_VIEWER, "userful-chronos");
  var isControlRoomViewer = isDecisionsAdmin || ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS.CONTROL_ROOM_VIEWER, "userful-chronos");
  var isControlRoomCreator = isDecisionsAdmin || ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS.CONTROL_ROOM_CREATOR, "userful-chronos");
  var isControlRoomUpdater = isDecisionsAdmin || ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS.CONTROL_ROOM_UPDATER, "userful-chronos");
  var isRubyAllowed = ROLES.hasCapability(capabilities, ROLES.CAPABILITIES.REMOTE) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.OPSTREAMS);
  var isTrendsAllowed = ROLES.hasCapability(capabilities, ROLES.CAPABILITIES.TRENDS) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.TRENDS);
  var isDecisionsdAllowed = ROLES.hasCapability(capabilities, ROLES.CAPABILITIES.DECISIONS) && (ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.DECISIONS) || ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS_AETHER.CONTROL_ROOM, "userful-chronos-aether") || ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS_AETHER.CONTROL_ROOM_MANAGER, "userful-chronos-aether"));
  var isEngageAllowed = ROLES.hasCapability(capabilities, ROLES.CAPABILITIES.ENGAGE) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.ENGAGE);
  var isSapphireAllowed = ROLES.hasCapability(capabilities, ROLES.CAPABILITIES.SPACES) && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.SPACES);
  var isUConductAllowed = ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.UCONDUCT);
  var hasMappingGroupsAccess = ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS_AETHER.MAPPING_GROUPS, "userful-chronos-aether") && ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS.MAPPER_VIEWER, "userful-chronos");
  var isMappingGroupUpdater = hasMappingGroupsAccess && ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS.MAPPING_GROUP_UPDATE, "userful-chronos");
  var hasCmsToolAccess = isEngagedUser && ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS_AETHER.CMS_TOOL, "userful-chronos-aether");
  var isMappingGroupEditor = hasMappingGroupsAccess && isMapperCreator && isMapperUpdater && isMapperViewer;
  var canEditMappingGroup = isAdminUser || isMappingGroupEditor && ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS_AETHER.EDIT_MAPPING_GROUP, "userful-chronos-aether");
  var canEditTextOverlay = isAdminUser || isMappingGroupEditor && ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS_AETHER.EDIT_TEXT_OVERLAY, "userful-chronos-aether");
  var canEditPlaylist = isAdminUser || isDecisionsOperator || isMappingGroupEditor && ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS_AETHER.EDIT_PLAYLIST, "userful-chronos-aether");
  var canEditMultiWindow = isAdminUser || isMappingGroupEditor && ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS_AETHER.EDIT_MULTI_WINDOW, "userful-chronos-aether");
  var isTabletCtrlAdmin = isAdminUser || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.TABLET_CONTROLLER_ADMIN);
  var isTabletCtrlUser = isTabletCtrlAdmin || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.TABLET_CONTROLLER);
  var uStreamTrendsAdmin = isAdminUser || isTabletCtrlAdmin && isTrendsAdmin;
  var uStreamEngageAdmin = isAdminUser || isTabletCtrlAdmin && isEngageAdmin;
  var uStreamDecisionAdmin = isAdminUser || isTabletCtrlAdmin && isDecisionsAdmin;
  var isUserManagementAdmin = ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.USER_MANAGEMENT_ADMIN);
  var canAccessSystemConfig = ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS_AETHER.SYSTEM_CONFIGURATION, "userful-chronos-aether");
  var isSystemConfigAdmin = canAccessSystemConfig && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.SYSTEM_CONFIG_ADMIN);
  var isSystemConfigViewer = isSystemConfigAdmin || canAccessSystemConfig && ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.SYSTEM_CONFIG_VIEWER);
  var hasMonitoringDashboardAccess = ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.MONITORING_DASHBOARD_ACCESS);
  var hasSourcesDestinationsAccess = ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.SOURCES_DESTINATIONS_ACCESS);
  var isUConductManager = isAdminUser || ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.UCONDUCT_MANAGER);
  var isUConductOperator = ROLES.hasRealmRole(keycloak, ROLES.USERFUL_REALM.UCONDUCT_OPERATOR);
  var hasNotificationsAccess = isAdminUser || isDecisionsAdmin || isRubyAdmin || isSapphireAdmin || isTrendsAdmin || isEngageAdmin || isTabletCtrlAdmin || isUConductManager;
  var canStartInteractiveViewer = ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS_AETHER.START_INTERACTIVE_VIEWER, "userful-chronos-aether");
  var canStopInteractiveViewer = ROLES.hasResourceRole(keycloak, ROLES.USERFUL_CHRONOS_AETHER.STOP_INTERACTIVE_VIEWER, "userful-chronos-aether");
  var permissions = {
    isAdminUser: isAdminUser,
    isDecisionsAdmin: isDecisionsAdmin,
    isDecisionsOperator: isDecisionsOperator,
    isDecisionsUser: isDecisionsUser,
    isEngageAdmin: isEngageAdmin,
    isEngagedUser: isEngagedUser,
    isRubyAdmin: isRubyAdmin,
    isRubyUser: isRubyUser,
    isSapphireAdmin: isSapphireAdmin,
    isSapphireUser: isSapphireUser,
    isTrendsAdmin: isTrendsAdmin,
    isTrendsUser: isTrendsUser,
    isMapperViewer: isMapperViewer,
    isMapperCreator: isMapperCreator,
    isMapperUpdater: isMapperUpdater,
    isControlRoomViewer: isControlRoomViewer,
    isControlRoomCreator: isControlRoomCreator,
    isControlRoomUpdater: isControlRoomUpdater,
    isUserManagementAdmin: isUserManagementAdmin,
    isMapperSuppressor: isMapperSuppressor,
    isMapperAdmin: isMapperAdmin,
    isSourceSuppressor: isSourceSuppressor,
    isRubyAllowed: isRubyAllowed,
    isTrendsAllowed: isTrendsAllowed,
    isDecisionsdAllowed: isDecisionsdAllowed,
    isEngageAllowed: isEngageAllowed,
    isSapphireAllowed: isSapphireAllowed,
    hasMappingGroupsAccess: hasMappingGroupsAccess,
    hasCmsToolAccess: hasCmsToolAccess,
    canEditMappingGroup: canEditMappingGroup,
    canEditTextOverlay: canEditTextOverlay,
    canEditPlaylist: canEditPlaylist,
    canEditMultiWindow: canEditMultiWindow,
    isTabletCtrlUser: isTabletCtrlUser,
    isTabletCtrlAdmin: isTabletCtrlAdmin,
    isSystemConfigAdmin: isSystemConfigAdmin,
    isSystemConfigViewer: isSystemConfigViewer,
    hasMonitoringDashboardAccess: hasMonitoringDashboardAccess,
    hasSourcesDestinationsAccess: hasSourcesDestinationsAccess,
    clearanceData: clearanceData,
    hasNotificationsAccess: hasNotificationsAccess,
    canOverrideSecurityDataOwnerShip: canOverrideSecurityDataOwnerShip,
    isUConductAllowed: isUConductAllowed,
    isUConductOperator: isUConductOperator,
    uStreamTrendsAdmin: uStreamTrendsAdmin,
    uStreamEngageAdmin: uStreamEngageAdmin,
    uStreamDecisionAdmin: uStreamDecisionAdmin,
    isUConductManager: isUConductManager,
    isSAMSourceViewer: isSAMSourceViewer,
    isEdgeAIUser: isEdgeAIUser,
    isMappingGroupUpdater: isMappingGroupUpdater,
    canStartInteractiveViewer: canStartInteractiveViewer,
    canStopInteractiveViewer: canStopInteractiveViewer
  };
  return permissions;
};
var getUserRoles = exports.getUserRoles = function getUserRoles(keycloak) {
  var roles = keycloak.tokenParsed.realm_access.roles;
  return roles.filter(function (role) {
    return !FILTERED_ROLES.includes(role);
  });
};
var ROLES = {
  CAPABILITIES: {
    DECISIONS: "li-diamond-allow",
    ENGAGE: "li-emerald-allow",
    SPACES: "li-sapphire-allow",
    TRENDS: "li-topaz-allow",
    REMOTE: "li-ruby-allow",
    ARTISTIC: "li-amethyst-allow"
  },
  USERFUL_REALM: {
    ADMIN: "admin",
    USER_MANAGEMENT_ADMIN: "user_management_admin",
    DECISION_ADMIN: "decisions_admin",
    DECISION_OPERATOR: "decisions_operator",
    DECISION_USER: "decisions_user",
    ENGAGE_ADMIN: "engage_admin",
    ENGAGE_USER: "engage_user",
    OPSTREAMS_ADMIN: "opstreams_admin",
    OPSTREAMS_USER: "opstreams_user",
    SPACE_ADMIN: "spaces_admin",
    SPACE_USER: "spaces_user",
    TRENDS_ADMIN: "trends_admin",
    TRENDS_USER: "trends_user",
    DECISIONS: "Decisions",
    ENGAGE: "Engage",
    SPACES: "Spaces",
    TRENDS: "Trends",
    OPSTREAMS: "OPStreams",
    UCONDUCT: "UConduct",
    TABLET_CONTROLLER: "TabletController",
    TABLET_CONTROLLER_ADMIN: "tablet_ctrl_admin",
    SYSTEM_CONFIG_ADMIN: "system_config_admin",
    SYSTEM_CONFIG_VIEWER: "system_config_viewer",
    MONITORING_DASHBOARD_ACCESS: "monitoring_dashboard",
    SOURCES_DESTINATIONS_ACCESS: "sources_destinations_admin",
    UCONDUCT_OPERATOR: "uconduct_operator",
    UCONDUCT_MANAGER: "uconduct_manager",
    EDGE_AI: "EdgeAI"
  },
  USERFUL_CHRONOS: {
    POWER_MANGER: "PowerManager",
    CHANNEL_VIEWER: "ChannelViewer",
    MEETING_ROOM_VIEWER: "MeetingRoomViewer",
    CHANNEL_CREATOR: "ChannelCreator",
    FAIL_OVER_MANAGER: "FailoverManager",
    CHANNEL_SUPPRESSOR: "ChannelSuppressor",
    MAPPER_CREATOR: "MapperCreator",
    MAPPER_VIEWER: "MapperViewer",
    MAPPER_UPDATER: "MapperUpdater",
    MAPPER_SUPPRESSOR: "MapperSuppressor",
    SOURCE_SUPPRESSOR: "SourceSuppressor",
    REMOTE_SUPPORT: "RemoteSupport",
    GENERAL_SETTING_MANAGER: "GeneralSettingManager",
    BROADCAST_MANAGER: "BroadcastManager",
    MEETING_ROOM_CREATOR: "MeetingRoomCreator",
    ENDPOINT_MANAGER: "EndPointManager",
    LICENSE_UPDATER: "LicenseUpdater",
    CHANNEL_UPDATER: "ChannelUpdater",
    MEETING_ROOM_UPDATER: "MeetingRoomUpdater",
    LICENSE_VIEWER: "LicenseViewer",
    LICENSE_MANAGER: "LicenseManager",
    SYSTEM_MONITORING_DASHBOARD: "SystemMonitoringDashboard",
    PLAYLIST_VIEWER: "SamPlayListDefViewer",
    PLAYLIST_CREATOR: "SamPlayListDefCreator",
    PLAYLIST_UPDATER: "SamPlayListDefUpdater",
    PLAYLIST_SUPPRESSOR: "SamPlayListDefSuppressor",
    CONTROL_ROOM_CREATOR: "ControlRoomCreator",
    CONTROL_ROOM_UPDATER: "ControlRoomUpdater",
    CONTROL_ROOM_VIEWER: "ControlRoomViewer",
    OVERRIDE_SECURITY_DATA_OWNERSHIP: "OverrideSecurityDataOwnership",
    SAM_SOURCE_VIEWER: "SamSourceViewer",
    MAPPING_GROUP_UPDATE: "MappingGroupUpdater"
  },
  USERFUL_CHRONOS_AETHER: {
    LAUNCHER: "Launcher",
    CMS_TOOL: "CmsTool",
    CONTROL_ROOM: "ControlRoom",
    MEETING_ROOM: "MeetingRooms",
    MAPPING_GROUPS: "MappingGroups",
    CONTROL_ROOM_MANAGER: "ControlRoomMgr",
    SYSTEM_CONFIGURATION: "SystemConfiguration",
    SOURCES_DESTINATIONS: "SourcesDestinations",
    EDIT_TEXT_OVERLAY: "EditTextOverlay",
    EDIT_MAPPING_GROUP: "EditMappingGroup",
    EDIT_PLAYLIST: "EditPlaylist",
    EDIT_MULTI_WINDOW: "EditMultiWindow",
    START_INTERACTIVE_VIEWER: "StartInteractiveViewer",
    STOP_INTERACTIVE_VIEWER: "StopInteractiveViewer"
  },
  hasCapability: function hasCapability(capabilities, capabilityName) {
    if (!capabilities) {
      return true;
    }
    var _iterator = _createForOfIteratorHelper(capabilities.capabilities),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var capabiliy = _step.value;
        if (capabiliy.name === capabilityName) {
          return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return false;
  },
  hasRole: function hasRole(userRoles, role) {
    return userRoles.includes(role);
  },
  hasRealmRole: function hasRealmRole(keycloak, role) {
    if (Array.isArray(keycloak)) {
      return keycloak.includes(role);
    }
    return keycloak.hasRealmRole(role);
  },
  hasResourceRole: function hasResourceRole(keycloak, role, resource) {
    if (Array.isArray(keycloak)) {
      return keycloak.includes(role);
    }
    return keycloak.hasResourceRole(role, resource);
  }
};